import { allow } from '../classes/allow';
import capitalizeFirstLetter from './capitalize.first.letter';

export default function capitalizeWords(text = '') {
   allow.aString(text);
   const words = text.split(' ');
   const capitalizedWords = words.map(word => capitalizeFirstLetter(word));
   return capitalizedWords.join(' ');
}